import React from 'react'
import PropTypes from 'prop-types'

import BasePressIcon from './PressIcon.base'

const PeopleMagazine = ({ className, ...props }) => (
  <BasePressIcon className={className} onClick={() => props.onClick('people_magazine')} box='0 0 3000 1200'>
    <path className="st0" d="M1613.45,304.2v115.42c-31.84-93.58-129.72-128.24-187-128.03c-31.96,0.16-168.3,14.13-208.26,199.11
    c-36.96-242.84-257.96-224.73-351.24-143.59c-4.95-61.21-17.14-143.86-78.2-191.95c-33.05-26.02-82.09-47.04-151.09-47.04H271.59
    v130.42c63.73,0.49,66.01,61.21,66.01,70.52v392.26c0.07,44.31-16.84,73.12-66.23,73.5v129.57h339.18V772.11
    c-49.39-0.36-65.69-26.85-65.61-71.11V591l57.67,0.1c68.76-2.56,126.61,5.77,189.11-61.31c-1.74,18.5-6.73,56.13-6.73,75.55
    c-2.36,96.28,8.83,185.56,66.9,244.6c1.41,1.46,59.22,67.85,155.75,69.05c53.76,0.77,176.12-9.38,208.62-193.45
    c7.46,24.83,46.84,193.72,220.94,193.72c175.74,0,212.39-159.94,221.15-209.44v196.74c-0.43,52.41-38.86,75.89-62.85,76.62v108.61
    l285.66-0.07V983.15c-31.71-4.3-61.48-33.85-61.99-80.52l-2.33-75.23c24.89,69.11,92.53,91.75,120.03,91.9
    c32.87,0.08,107.82-18.05,129.19-149.02v134.03h244.79V771.74c31.08,203.55,386.11,201.51,407.33-55.24h-168.63
    c-6.28,36.84-22.51,66.1-53.34,65.95v0c-37.79,0.21-53.69-43.54-56.01-91.8c-0.87-17.29-1.93-36.01-0.95-47.17l283.98-0.09
    c2.6-58.19,5.69-147.94-37.59-232.93c-33.83-66.36-99.77-118.26-192.89-118.26c-91.66,0-200.48,62.42-221.77,257.56V109.32h-233.43
    l0.15,108.61c39.31-0.23,63.33,20.05,63.48,59.35V549.6c-25.41-204.49-124.49-258.24-172.82-257.94
    c-50.2,0.3-99.67,30.72-114.44,86.77V304.2H1613.45z M593.13,442.84h-47.59V258.75h47.59c37.06,0,58.12,31.12,58.12,91.06
    C651.25,415.67,636.26,441.64,593.13,442.84z M954.73,520.08c2.34-48.26,19.44-94.53,57.28-94.35
    c37.87-0.22,52.53,46.07,54.91,94.35c0.82,16.4,1.15,17.18,0,29.39h-112.2C953.58,537.26,953.91,536.47,954.73,520.08z
     M1066.39,716.87c-6.34,36.83-22.59,65.74-53.39,65.59c-37.83,0.21-53.71-43.54-56.09-91.8c-0.85-17.29-1.89-36.01-0.93-47.17
    l249.1-0.09c0.82,28.75,1.68,36.48,9.16,73.38L1066.39,716.87z M1437.13,783.74c-44.15-0.62-61.75-79.37-61.75-177.27
    c0-97.88,18.82-177.79,61.75-177.24c44.18,0.6,61.77,79.37,61.77,177.24C1498.9,704.37,1482.51,784.35,1437.13,783.74z
     M2439.05,520.1c2.44-48.28,18.31-90.99,56.13-90.8c37.8-0.19,53.72,42.52,56.13,90.8c0.81,16.4,1.08,17.18,0,29.38h-112.26
    C2437.95,537.28,2438.28,536.49,2439.05,520.1z M1875.67,424.24c36.25,1.56,57.07,47.9,57.07,182.8c0,122.87-23,175.16-61.59,175.16
    c-34.51,0-46.66-37.41-46.66-86.59V514.06C1822.68,452.52,1840.61,422.67,1875.67,424.24z" />
  </BasePressIcon>
)

PeopleMagazine.propTypes = {
  className: PropTypes.string
}

export default PeopleMagazine



// WEBPACK FOOTER //
// ./src/core/icons/press/PeopleMagazine.base.js